export const Language = {
	en: {
		header: {
			logo: 'Where in the world?',
			dark: 'Dark Mode',
			light: 'Light Mode',
			placeholder: 'Search for a country',
			filterOne: 'Filter by Region',
			africa: 'Africa',
			america: 'Americas',
			asia: 'Asia',
			europe: 'Europe',
			oceania: 'Oceania',
		},
		cards: {
			population: 'Population',
			region: 'Region',
			capital: 'Capital',
		},
		single: {
			back: 'Back',
			name: 'Native Name',
			population: 'Population',
			region: 'Region',
			capital: 'Capital',
			subregion: 'Sub Region',
			domain: 'Top Level Domain',
			currencies: 'Currencies',
			languages: 'Languages',
			borders: 'Borders',
		},
	},
	uz: {
		header: {
			logo: 'Dunyoning qayerida?',
			dark: 'Tun',
			light: 'Kun',
			placeholder: 'Davlatni qidiring',
			filterOne: "Region bo'yicha saralash",
			africa: 'Afrika',
			america: 'Amerika',
			asia: 'Osiyo',
			europe: 'Yevropa',
			oceania: 'Okeania',
		},
		cards: {
			population: "Ko'payish",
			region: 'Mintaqa',
			capital: 'Poytaxt',
		},
		single: {
			back: 'Orqaga',
			name: 'Asl ismi',
			population: 'Aholisi',
			region: 'Mintaqa',
			capital: 'Poytaxt',
			subregion: 'Yarim Mintaqa',
			domain: 'Mashxur Domen',
			currencies: 'Pul birligi',
			languages: 'Tili',
			borders: 'Chegaradoshlari',
		},
	},
	ru: {
		header: {
			logo: 'Где в мире?',
			dark: 'Темный режим',
			light: 'Солнечный режим',
			placeholder: 'Поиск страны',
			filterOne: 'Фильтровать по региону',
			africa: 'Африка',
			america: 'Америка',
			asia: 'Азия',
			europe: 'Европа',
			oceania: 'Океания',
		},
		cards: {
			population: 'Население',
			region: 'Область',
			capital: 'Столица',
		},
		single: {
			back: 'Назад',
			name: 'Родное имя',
			population: 'Население',
			region: 'Область',
			capital: 'Столица',
			subregion: 'Подрегион',
			domain: 'Домен верхнего уровня',
			currencies: 'Валюты',
			languages: 'Языки',
			borders: 'Границы',
		},
	},
};
